import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-catalogs-config-card',
  templateUrl: './catalogs-config-card.component.html',
  styleUrls: ['./catalogs-config-card.component.scss']
})
export class CatalogsConfigCardComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
